import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { ErrorConstant, PLACE_HOLDER, SECTION_NAME } from '../../models';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { EarnsSummaryService } from '../../services/api/earns-summary.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class EarnsSummaryEffects {
  loadEarnsSummaryData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadEarnsSummary),
      switchMap(() =>
        combineLatest([
          this.overview.serviceConfiguration$.pipe(
            filter(
              (serviceConfiguration) => !!serviceConfiguration?.carrierCode
            ),
            take(1)
          ),
          this.overview.aemErrorMessages$.pipe(
            filter((aemErrorMessages) => aemErrorMessages !== undefined),
            take(1)
          )
        ]).pipe(
          switchMap(([payload, aemErrorMessages]) =>
            this.earnsSummary.getEarnsSummary(payload).pipe(
              map((content) =>
                OverviewActions.loadEarnsSummarySuccess({
                  earnsSummary: {
                    id: 'earns-summary-content',
                    earnsSummaryData: content
                  }
                })
              ),
              catchError((error: HttpErrorResponse) => {
                const message = aemErrorMessages.find((item) => {
                  return item.component === 'earns-summary';
                });
                this.dataLayer.setErrorData(
                  error,
                  message.errorMessageDescription,
                  ErrorConstant.EVENT_NAME.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.EARN_SUMMARY
                  ),
                  ErrorConstant.TYPE.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.EARN_SUMMARY
                  )
                );
                return of(
                  OverviewActions.loadEarnsSummaryFailure({
                    error: {
                      id: 'earns-summary-content-error',
                      earnsSummaryDataError: 'earns-summary'
                    }
                  })
                );
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly earnsSummary: EarnsSummaryService,
    private readonly overview: OverviewFacade,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
